module.exports = "/images/cold@2x.png?3081c7284f7e3d4591824787cd88a858";